(ns app.bundle-social.text
  "Text helpers for the posts' fields, shared by the catalog and the
   platform slices (which cannot require `app.bundle-social.platforms`,
   since it requires them)."
  (:require [clojure.string :as str]))

(def ellipsis
  "…")

(defn shorten
  "`text` cut to at most `max-length` characters, ending with an
   ellipsis; unchanged when it fits. Never splits a surrogate pair (an
   emoji), which would leave a broken character."
  [text max-length]
  (if (<= (count text) max-length)
    text
    (let [end (dec max-length)
          end (if (and (pos? end)
                       #?(:clj (Character/isHighSurrogate (.charAt ^String text (dec end)))
                          :cljs (<= 0xD800 (.charCodeAt text (dec end)) 0xDBFF)))
                (dec end)
                end)]
      (str (str/trimr (subs text 0 end)) ellipsis))))

(defn utf8-length
  "The number of bytes of `text` in UTF-8."
  [text]
  #?(:clj (alength (.getBytes ^String text "UTF-8"))
     :cljs (.-length (.encode (js/TextEncoder.) text))))

(defn shorten-bytes
  "Like `shorten`, for a limit in UTF-8 bytes (YouTube's description):
   an umlaut or an emoji takes more than one byte. Never shorter than
   the ellipsis alone, so a `max-bytes` below its 3 bytes is not met."
  [text max-bytes]
  (loop [max-length (max 1 (min (count text) max-bytes))]
    (let [shortened (shorten text max-length)
          excess (- (utf8-length shortened) max-bytes)]
      (if (and (pos? excess) (< 1 max-length))
        ;; A char (UTF-16 code unit) takes at most 3 bytes, so cutting
        ;; excess/4 chars never cuts too much; it approaches from above.
        (recur (max 1 (- max-length (max 1 (quot excess 4)))))
        shortened))))

(defn url?
  "An http(s) url without whitespace, as a destination link."
  [s]
  (boolean
    (and (string? s)
         (<= (count s) 2048)
         (re-matches #"https?://[^\s]+" s))))

(defn format-credits
  "Two decimals in clj and cljs alike: `str` renders 0.10M as \"0.10\"
   on the JVM, but as \"0.1\" in the browser."
  [amount]
  #?(:clj (String/format java.util.Locale/US "%.2f" (to-array [(double amount)]))
     :cljs (.toFixed (double amount) 2)))
